import React, { useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';
import momencik from '../../../common/momencik';

import { SalesInvoicePaymentsSearch } from './SalesInvoicePaymentsSearch';
import { SalesInvoicePaymentsSummary } from './SalesInvoicePaymentsSummary';

interface SalesInvoicePaymentsModalProps {
  invoiceNumber: string;
  invoiceDate?: Date;
  show: boolean;
  onClose: () => void;
}

export const SalesInvoicePaymentsModal: React.FC<
  SalesInvoicePaymentsModalProps
> = props => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('fvsLng');

  const getData = useCallback(
    ((
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      pok.salesInvoicePayments.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        props.invoiceNumber,
      )) as GridGetterFunction,
    [pok.salesInvoicePayments, props.invoiceNumber],
  );

  const getCount = useCallback(
    ((filterText, filterColumns) =>
      pok.salesInvoicePayments.getAllCount(
        filterText,
        filterColumns,
        props.invoiceNumber,
      )) as GridCountFunction,
    [pok.salesInvoicePayments, props.invoiceNumber],
  );

  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      size="xl"
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t(tk.finance.paymentsFor)}
          {': '}
          <strong>{props.invoiceNumber}</strong>
          {props.invoiceDate && (
            <span className="text-muted ms-2 fs-6">
              ({t(tk.finance.fromDate)} {momencik(props.invoiceDate)})
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SalesInvoicePaymentsSummary invoiceNumber={props.invoiceNumber} />
        <SalesInvoicePaymentsSearch getData={getData} getCount={getCount} />
      </Modal.Body>
    </Modal>
  );
};
